import { render, staticRenderFns } from "./EditProFormaInvoice.vue?vue&type=template&id=4afb5ea6"
import script from "./EditProFormaInvoice.vue?vue&type=script&lang=js"
export * from "./EditProFormaInvoice.vue?vue&type=script&lang=js"
import style0 from "./EditProFormaInvoice.vue?vue&type=style&index=0&id=4afb5ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports